<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="app首页底部标签名" prop="tagName" >
        <a-input  v-model="form.tagName" placeholder="请输入app首页底部标签名" />
      </a-form-model-item>
      <a-form-model-item label="点击显示图片" prop="imgUrl" >
        <a-upload
          listType="picture-card"
          class="avatar-uploader"
          v-model="form.imgUrl"
          :showUploadList="false"
          :action="`${uploadBaseUrl}/common/local/file/uploadCos`"
          :beforeUpload="beforeUpload"
          :customRequest="handleChange"
        >
          <div v-if="form.imgUrl" class="upload-image-wrapper">
            <img
              :src="form.imgUrl"
              alt="logo"
              style="height:104px;max-width:300px"/>
            <div v-if="uploadLoading" class="upload-mask">
              <a-icon type="loading" style="font-size: 24px; color: #1890ff;"/>
            </div>
          </div>
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>


      <a-form-model-item label="未点击显示图片" prop="imgUrlNo" >
        <a-upload
          listType="picture-card"
          class="avatar-uploader"
          v-model="form.imgUrlNo"
          :showUploadList="false"
          :action="`${uploadBaseUrl}/common/local/file/uploadCos`"
          :beforeUpload="beforeUploads"
          :customRequest="handleChanges"
        >
          <div v-if="form.imgUrlNo" class="upload-image-wrapper">
            <img
              :src="form.imgUrlNo"
              alt="logo"
              style="height:104px;max-width:300px"/>
            <div v-if="uploadLoadings" class="upload-mask">
              <a-icon type="loading" style="font-size: 24px; color: #1890ff;"/>
            </div>
          </div>
          <div v-else>
            <a-icon :type="uploadLoadings ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>




      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getVideo, addVideo, updateVideo } from '@/api/video/appImg'
import UploadFileToVOD from "@/api/vod";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      uploadBaseUrl: process.env.VUE_APP_BASE_API,
      submitLoading: false,
      uploadLoading: false,
      uploadLoadings: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        tagName: null,

        imgUrl: null,
        imgUrlNo: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    handleChange(info) {
      const that = this
      that.uploadLoading = true
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.imgUrl = fileName[0]// 文件名
          that.uploadLoading = false
        },
        error: function () {
          that.uploadLoading = false
          that.$message.error('上传失败，请重试')
        }
      })
    },
    beforeUpload: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片')
        this.uploadLoading = false
        return false
      }
      this.form.imgUrl = ''
      this.uploadLoading = true
      // TODO 驗證文件大小
    },




    handleChanges(info) {
      const that = this
      that.uploadLoadings = true
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.imgUrlNo = fileName[0]// 文件名
          that.uploadLoadings = false
        },
        error: function () {
          that.uploadLoadings = false
          that.$message.error('上传失败，请重试')
        }
      })
    },
    beforeUploads: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片')
        this.uploadLoadings = false
        return false
      }
      this.form.imgUrlNo = ''
      this.uploadLoadings = true
      // TODO 驗證文件大小
    },


    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        tagName: null,
        imgUrl: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getVideo({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateVideo(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addVideo(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.upload-image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.upload-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 4px;
}

.avatar-uploader {
  :deep(.ant-upload-select-picture-card) {
    width: 104px;
    height: 104px;
  }

  :deep(.ant-upload-select-picture-card:hover) {
    border-color: #1890ff;
  }
}
</style>
